const DEBUG = false;
// const DEBUG = true;

export const log = (...args) => {
	if(!DEBUG) return;
	console.warn(...args);
}


// WEBPACK FOOTER //
// ./utils/logging.js